var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import withBranding from "@irati/brand/withBranding";
import defaultAuth from "@irati/auth/helpers/defaultAuth";
import { H3 } from "@irati/ui/src/Headings";
import { Para } from "@irati/ui/src/Labels";
import Button from "@irati/ui/src/Button";
import { FormattedMessage } from "@irati/utils/lang";
import Flex from "@irati/ui/src/Flex";
import PlaceholderBar, { PlaceholderContainer, PlaceholderGrid, PlaceholderSquare } from "@irati/ui/src/Placeholder";
import { HeaderBar, MockPBLogo, DottedLogo, DottedBrandLine, LogoText, BrandLine } from "./styled";
export var PreviewVariants;
(function (PreviewVariants) {
    PreviewVariants["Default"] = "Default";
    PreviewVariants["Unset"] = "Unset";
    PreviewVariants["Custom"] = "Custom";
})(PreviewVariants || (PreviewVariants = {}));
var BrandPreview = /** @class */ (function (_super) {
    __extends(BrandPreview, _super);
    function BrandPreview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getLinkAndColor = function () {
            var _a = _this.props, variant = _a.variant, branding = _a.branding;
            if (variant === PreviewVariants.Default) {
                var _b = defaultAuth.userTenant.settings, imageLink = _b.imageLink, color = _b.color;
                return { imageLink: imageLink, color: color };
            }
            else {
                var imageLink = branding.businessLogoUrl, color = branding.textColour;
                return { imageLink: imageLink, color: color };
            }
        };
        return _this;
    }
    BrandPreview.prototype.render = function () {
        var _a = this.props, variant = _a.variant, handleClick = _a.handleClick, forceColor = _a.forceColor, branding = _a.branding;
        var PBLogoLink = branding.businessLogoUrl;
        var isUnset = variant === PreviewVariants.Unset;
        var isCustom = variant === PreviewVariants.Custom;
        var _b = this.getLinkAndColor(), imageLink = _b.imageLink, color = _b.color;
        return (React.createElement(React.Fragment, null,
            React.createElement(Flex, { alignItems: "center", justifyContent: "space-between", height: "60px" },
                React.createElement(H3, null,
                    React.createElement(FormattedMessage, { id: "setup_tenant.steps.brand.brandPreview.title" })),
                isUnset && (React.createElement(Button, { primary: true, onClick: handleClick },
                    React.createElement(FormattedMessage, { id: "setup_tenant.steps.brand.brandPreview.setBrandButton" }))),
                isCustom && (React.createElement(Button, { primary: true, onClick: handleClick },
                    React.createElement(FormattedMessage, { id: "setup_tenant.steps.brand.brandPreview.updateBrandButton" })))),
            React.createElement(Para, null,
                React.createElement(FormattedMessage, { id: "setup_tenant.steps.brand.brandPreview.text" })),
            React.createElement(PlaceholderContainer, null,
                React.createElement(HeaderBar, null,
                    React.createElement(MockPBLogo, { src: PBLogoLink }),
                    !isUnset && React.createElement(MockPBLogo, { src: imageLink }),
                    isUnset && (React.createElement(DottedLogo, null,
                        React.createElement(LogoText, null,
                            React.createElement(FormattedMessage, { id: "setup_tenant.steps.brand.brandPreview.logoText" }))))),
                isUnset && React.createElement(DottedBrandLine, null),
                !isUnset && React.createElement(BrandLine, { brandColor: forceColor || color, isMobile: false }),
                React.createElement(PlaceholderContainer, { border: "none", padding: "30px" },
                    React.createElement(PlaceholderBar, { type: "dark", margin: "0 0 30px 0", width: "20%" }),
                    React.createElement(PlaceholderBar, { margin: "30px 0", width: "10%" }),
                    React.createElement(PlaceholderGrid, { rows: 1, columns: 3 }),
                    React.createElement(PlaceholderSquare, { margin: "15px 0 0 0" })))));
    };
    return BrandPreview;
}(PureComponent));
export default withBranding(BrandPreview);
